// What the page keeps between visits in localStorage: the font size of each column, where the
// column divider sits, and whether the folder banner was dismissed (decision 14). The shell's A−
// and A+ (core/appearance.ts, brief 42) size a language's rows inside a project's appearance, so
// the aligner keeps its own size per column, in its own steps.

const PREFIX = 'interplae.align.'

export function getPref<T>(key: string, fallback: T): T {
  try {
    const raw = localStorage.getItem(PREFIX + key)
    return raw === null ? fallback : (JSON.parse(raw) as T)
  } catch {
    return fallback
  }
}

export function setPref(key: string, value: unknown) {
  try {
    localStorage.setItem(PREFIX + key, JSON.stringify(value))
  } catch {
    // Storage full or refused: the preference lasts for this visit only.
  }
}

export const FONT_SIZES = [11, 12, 13, 14, 15, 16, 18, 20, 22, 24, 28]
export const DEFAULT_FONT = { Source: 14, Target: 16 }
